import { useContext } from "react";
import { SportsCampsContext } from "./context/sportscamps-context";
import Loading from "./Loading/Loading";

const SportsCampsResults = (props) => {
	const { dictionaryWords, sportsCamps, sportsCampsCards, isLoading, page } =
		useContext(SportsCampsContext);

	return (
		<>
			<div className="c-fiche-wrap u-clear">
				{sportsCampsCards}
			</div>

			{isLoading ? (
				<Loading />
			) : (
				<>
					{sportsCamps.AmountOfPages > page && (
						<div className="status">
							<button
								className="c-button"
								onClick={props.loadMore}
							>
								{dictionaryWords.loadMore}
							</button>
						</div>
					)}
				</>
			)}

			{sportsCamps.totalAmount === 0 && (
				<div className="status empty">
					<p>{dictionaryWords.noSportsCamps}</p>
				</div>
			)}
		</>
	);
};

export default SportsCampsResults;
